import { routeConstant } from "shared/routes/routeConstant";
import { ProjectDetailTabs } from "shared/utils/enum";

export interface NotificationTarget {
  path: string;
  state: Record<string, unknown>;
}

interface NavigableNotification {
  type?: string | null;
  project?: { project_id?: number | null } | null;
}

const CHAT_TYPES = [
  "comment_added",
  "new_comment",
  "reply_added",
  "new_reply",
];

const projectDetailPathFor = (pathname: string, projectId: number) => {
  if (pathname.includes("/client/")) {
    return routeConstant.client.projectDetail.path.replace(
      ":id",
      String(projectId),
    );
  }
  if (pathname.includes("/collaborator/")) {
    return routeConstant.collaborator.projectDetail.path.replace(
      ":id",
      String(projectId),
    );
  }
  if (pathname.includes("/builder/")) {
    return routeConstant.builder.projectDetail.path.replace(
      ":id",
      String(projectId),
    );
  }
  return routeConstant.designer.projectDetail.path.replace(
    ":id",
    String(projectId),
  );
};

// Where clicking an activity lands, shared by the dashboard card and the notifications screen.
export const resolveNotificationTarget = (
  notification: NavigableNotification | null | undefined,
  pathname: string,
): NotificationTarget | null => {
  const projectId = notification?.project?.project_id;
  if (!projectId) {
    return null;
  }

  const path = projectDetailPathFor(pathname, projectId);
  const notificationType = (notification?.type || "").trim().toLowerCase();

  if (CHAT_TYPES.includes(notificationType)) {
    return {
      path,
      state: {
        activeTab: ProjectDetailTabs.CHAT_BOARD,
        fromNotification: true,
        fromChatBoard: true,
      },
    };
  }

  return { path, state: { fromNotification: true } };
};

export default resolveNotificationTarget;
